import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40fd547c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "nav-container"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "nav-ber"
};
const _hoisted_4 = {
  class: "flex m-r-15"
};
const _hoisted_5 = {
  class: "el-dropdown-link flex"
};
const _hoisted_6 = {
  class: "m-r-6 font-weight-600 font-18"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "dropdown-menu"
};
const _hoisted_9 = {
  class: "font-22 m-l-10"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-a-Vector1"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-a-guanbi4"
}, null, -1));
import { useStore } from "@/store/index";
import { ref, computed, watchEffect, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import api from "@/api/config/info.js";
import { onlineStatus } from "@/enums/msgType";
import storage from "@/utils/storage";
import { ElMessage } from "element-plus";
import { useLoading } from "@/hook";
export default {
  __name: 'Navber',
  setup(__props) {
    const {
      t
    } = useI18n();
    const store = useStore();
    const active = ref(false);
    const onlineList = computed(() => {
      return [{
        label: t("common.online"),
        class: "online",
        id: onlineStatus.online
      }, {
        label: t("common.busy"),
        class: "busy",
        id: onlineStatus.busy
      }];
    });
    const onlineState = computed(() => {
      const status = {
        [onlineStatus.offline]: "offline",
        [onlineStatus.online]: "online",
        [onlineStatus.busy]: "busy"
      };
      return status[store.info.status];
    });
    const value = ref(false);
    const handleClick = async id => {
      const loading = useLoading();
      try {
        await api.changeStatus({
          status: id
        });
        await store.getInfo();
        ElMessage.success(t("action.success"));
      } finally {
        loading.close();
      }
    };
    const theme = ref(storage.get("theme") || "light");
    const handleTheme = val => {
      theme.value = val ? "light" : "dark";
      storage.set("theme", theme.value);
      store.theme = theme.value;
    };
    watchEffect(() => {
      const subject = theme.value;
      value.value = subject === "light";
      nextTick(() => {
        const html = document.documentElement;
        subject === "dark" ? html.classList.add("dark") : html.classList.remove("dark");
      });
    });
    const handleChange = isShow => {
      if (!isShow) {
        active.value = isShow;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_lang_select = _resolveComponent("lang-select");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`route.${_ctx.$route.meta.title}`)), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_switch, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => value.value = $event),
        "active-text": _ctx.$t('common.light'),
        "inactive-text": _ctx.$t('common.dark'),
        onChange: handleTheme
      }, null, 8, ["modelValue", "active-text", "inactive-text"])]), _createVNode(_component_lang_select, {
        class: "right-menu-item hover-effect"
      }), _createVNode(_component_el_dropdown, {
        teleported: false,
        onVisibleChange: handleChange
      }, {
        dropdown: _withCtx(() => [_withDirectives(_createElementVNode("div", {
          class: "menu",
          onMouseenter: _cache[1] || (_cache[1] = $event => active.value = true),
          onMouseleave: _cache[2] || (_cache[2] = $event => active.value = false)
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(onlineList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            class: "menu-item flex p-l-20",
            key: item.label,
            onClick: $event => handleClick(item.id)
          }, [_createElementVNode("div", {
            class: _normalizeClass([item.class, "state"])
          }, null, 2), _createElementVNode("span", null, _toDisplayString(item.label), 1)], 8, _hoisted_7);
        }), 128))], 544), [[_vShow, active.value]]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
          class: "avatar flex",
          onMouseenter: _cache[3] || (_cache[3] = $event => active.value = false)
        }, [_createElementVNode("div", null, [_createVNode(_component_el_avatar, {
          src: _unref(store).info.avatar
        }, null, 8, ["src"]), _createElementVNode("span", {
          class: _normalizeClass(["online-state", onlineState.value])
        }, null, 2)]), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(store).info.name), 1)], 32), _createElementVNode("div", {
          class: "dropdown-item",
          onClick: _cache[4] || (_cache[4] = $event => _ctx.$router.push('/personal/personalCenter')),
          onMouseenter: _cache[5] || (_cache[5] = $event => active.value = false)
        }, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(_ctx.$t("route.PersonalCenter")), 1)], 32), _createElementVNode("div", {
          class: "dropdown-item",
          onClick: _cache[6] || (_cache[6] = (...args) => _unref(store).getOut && _unref(store).getOut(...args)),
          onMouseenter: _cache[7] || (_cache[7] = $event => active.value = false)
        }, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.logout")), 1)], 32)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(store).info.name), 1), _createVNode(_component_el_avatar, {
          src: _unref(store).info.avatar
        }, null, 8, ["src"]), _createElementVNode("span", {
          class: _normalizeClass(["online-state", onlineState.value])
        }, null, 2)])]),
        _: 1
      })])]);
    };
  }
};